<mat-sidenav-container
	class="sidebar"
	fullscreen
>
	<mat-sidenav
		#sidenav
		class="sidebar__container"
		[opened]="(isCatchBreakpoint$ | async) === false"
		[mode]="(isCatchBreakpoint$ | async) ? 'over' : 'side'"
	>
		@if (currentUser$ | async; as user) {
			<div
				class="sidebar__header-container"
				[class.sidebar__header-container_admin]="user.role === userRole.SuperAdmin"
			>
				<div
					*userHasRole="userRole.BusinessOwner"
					class="sidebar__company-logo"
				>
					@let logo = companyLogo$ | async;
					<div
						class="logo-loader"
						[protctcLoading]="logo === null"
					>
						<protctc-image-uploader-preview
							class="company-logo"
							alt="Company logo"
							[src]="logo?.url ?? 'assets/company_avatar_default.svg'"
						/>
					</div>
				</div>
				<div
					*userHasRole="userRole.SuperAdmin"
					class="sidebar__logo"
				>
					<a [routerLink]="routePaths.home">
						<protctw-main-logo class="sidenav-main__logo" />
					</a>
				</div>
				<div class="sidebar__user-info user-info">
					<div class="user-info__container">
						<p class="user-info__welcome">Welcome,</p>
						<p class="user-info__name">{{ user.firstName }} {{ user.lastName }}</p>
						<p
							*userHasRole="userRole.BusinessOwner"
							class="user-info__role"
						>
							{{ toReadableUserRole(user.role) }}
						</p>
					</div>
					<button
						#menuTrigger="matMenuTrigger"
						class="logout-button"
						mat-icon-button
						type="button"
						[matMenuTriggerFor]="menu"
					>
						@if (menuTrigger.menuOpen === false) {
							<mat-icon
								class="sidebar__icon sidebar__icon_drop-down"
								svgIcon="arrow_drop_down"
							/>
						}
						@if (menuTrigger.menuOpen) {
							<mat-icon
								class="sidebar__icon"
								svgIcon="arrow_drop_up"
							/>
						}
					</button>
				</div>
				<mat-menu
					#menu="matMenu"
					class="sidebar__mat-menu mat-menu"
					xPosition="before"
					yPosition="below"
					[overlapTrigger]="false"
				>
					<a
						class="mat-menu__link"
						mat-menu-item
						[routerLink]="
							user.role === userRole.BusinessOwner ? routePaths.accountSettings : routePaths.adminAccountSettings
						"
					>
						<mat-icon svgIcon="account_settings" />
						<span>Account settings</span>
					</a>
					<button
						mat-menu-item
						type="button"
						(click)="logout()"
					>
						<mat-icon svgIcon="sign_out" />
						<span>Sign out</span>
					</button>
				</mat-menu>
			</div>
		}

		<ul class="sidebar__navigation">
			@for (link of links$ | async; track link.route.join("/")) {
				<li class="sidebar__navigation-item">
					<a
						class="sidebar__link"
						routerLinkActive="active"
						[class.sidebar__link-with-children]="link.children"
						[class.sidebar__link-disabled]="link.disabled"
						[routerLink]="link.disabled ? null : link.route"
					>
						<span class="sidebar__link-wrapper">
							@if (link.icon) {
								<mat-icon
									class="sidebar__link-icon"
									[svgIcon]="link.icon"
								/>
							}
							{{ link.text }}
						</span>
						@if (link.children) {
							<button
								type="button"
								mat-icon-button
								class="expand-button"
								(click)="toggleOpenMenu(link.text, $event)"
							>
								@if (!isOpenedMenu(link.text)) {
									<mat-icon
										class="expand-icon expand-icon_more"
										svgIcon="expand_more"
									/>
								} @else {
									<mat-icon
										class="expand-icon"
										svgIcon="expand_less"
									/>
								}
							</button>
						}
					</a>
					@if (link.children && isOpenedMenu(link.text)) {
						<ul
							#subnav
							class="sidebar__subnavigation sidebar__navigation"
						>
							@for (child of link.children; track child.route.join("/")) {
								<li class="sidebar__subnavigation-item sidebar__navigation-item">
									<a
										class="sidebar__sublink sidebar__link"
										routerLinkActive="active"
										[class.sidebar__link-disabled]="child.disabled"
										[routerLink]="child.disabled ? null : child.route"
									>
										{{ child.text }}
									</a>
								</li>
							}
						</ul>
					}
				</li>
			}
		</ul>

		<footer
			*userHasRole="userRole.BusinessOwner"
			class="sidebar__footer"
		>
			<div class="sidebar__logo">
				<a [routerLink]="routePaths.home">
					<protctw-main-logo class="sidenav-main__logo" />
				</a>
			</div>
		</footer>
	</mat-sidenav>
	<mat-sidenav-content class="sidenav-main">
		@if (isCatchBreakpoint$ | async) {
			<mat-toolbar class="sidenav-main__header">
				<a [routerLink]="routePaths.home">
					<protctw-main-logo class="sidenav-main__logo" />
				</a>
				<button
					class="sidenav-main__button"
					type="button"
					mat-icon-button
					(click)="sidenav.toggle()"
				>
					<mat-icon>menu</mat-icon>
				</button>
			</mat-toolbar>
		}
		<div class="sidenav-main__content">
			@if (showMerchantNotReadyBanner$ | async) {
				<div class="merchant-not-ready-banner">
					<mat-icon
						class="merchant-not-ready-banner__icon"
						svgIcon="warning"
					/>
					<span class="merchant-not-ready-banner__text">
						Please note: Outstanding Invoices, Billing and Payments sections are temporarily unavailable. Access will be
						restored once the registration verification by the payment service is complete.
					</span>
				</div>
			}
			<protctw-breadcrumbs />
			<router-outlet />
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>
